import React from 'react';

import { Bubble } from '../bubble';
import { Container } from 'theme/layout';
import { Colors } from 'theme/colors';
import { DotIndicator } from 'components/base/indicator';

/**
 * Renders the loading component.
 *
 * @param props - Renders props
 */
export function LoadingBubble(props: LoadingProps) {
  const { loading } = props;

  if (!loading) {
    return null;
  }

  return (
    <Container maxWidth="850px" justifyContent="center" display="flex">
      <Bubble showTip={true} height={60}>
        <DotIndicator color={Colors.steel} count={3} size={6} />
      </Bubble>
    </Container>
  );
}
/* Type definitions */
interface LoadingProps {
  loading: boolean;
}
